import { useMutation } from "@tanstack/react-query";

import { awaitNativeEventOnce } from "../use-native-event-promise/use-native-event-promise";

import { POI_TIMEOUT_MS } from "./constants";

const CANCEL_POI_PAYMENT_MUTATION_KEY = "freedompay-cancel-payment";

export const useCancelPoiPayment = () => {
  return useMutation({
    mutationKey: [CANCEL_POI_PAYMENT_MUTATION_KEY],
    mutationFn: async () => {
      return awaitNativeEventOnce({
        timeoutMs: POI_TIMEOUT_MS,
        successEvent: "FREEDOMPAY_PAYMENT_CANCEL_SUCCESS",
        errorEvent: "FREEDOMPAY_PAYMENT_CANCEL_ERROR",
        sendEvent: "FREEDOMPAY_PAYMENT_CANCEL_REQUEST"
      });
    }
  });
};
